import { useParams } from "react-router-dom";
import { Modal, notification } from "antd";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from 'yup';
import axiosInstance from "../../../../Services/axiosCommon";
import { NuInput, NuInputText, NuTextArea } from "../../../../Components/Utils/Input";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import DropDownAddMetaData from "../../../../Components/Utils/selectAddMetaData";


const CreateCondition = ({open, getData, onCancel, data,projectList,firstProject }) => {
  const { value: title,getData:refTitle } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "title_Activity"
  );
  const { officeId } = useParams();
  const [api, contextHolder] = notification.useNotification();
  const [createNew, setCreateNew] = useState({
    item_code: '',
    description: '',
    branch: officeId
  });
  useEffect(() => {
    data&&setCreateNew({
      item_code:data.item_code,
      description:data.description,
    })
  },[data])
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema:yup.object({
      item_code:yup.string().required("Title is Requried")
    }),
    onSubmit: (value,{resetForm}) => {
     
      axiosInstance
      
      .post("/terms-and-condition/", value)
        .then((res) => {
          console.log(res);
          if (res.status === 201 || res.data.status == true) {
            getData();
            resetForm();
            api.success({
              message: `Description Creation successfully`,
              description: res?.data?.msg || "Added In The Description",
              placement: "bottomRight",
            });
            onCancel();
          } else {
            api.error({
              message: `Description Creation failed`,
              description: res?.data?.msg || "Network error",
              placement: "bottomRight",
            });
          }
        })
        .catch((err) => {
          api.error({
            message: `Description Creation failed`,
            description: err?.data?.msg || "Sever error (or) Network error",
            placement: "bottomRight",
          });
        });
    },
  });

  return (
    <>
    {contextHolder}
    <Modal
      open={open}
      title={data ? "Edit Terms & Conditions" : "Create  Terms & Conditions"}
      width={"50%"}
      className="my-modal"
      centered
      onCancel={onCancel}
      footer={[]}
    >
    <form onSubmit={formik.handleSubmit} >
     <div className=" w-full flex flex-wrap">
     <DropDownAddMetaData
                          label="Title"
                          placeholder="Choose"
                          Options={title}
                          formik={formik}
                          name="item_code"
                          width="w-full "
                          getFunc={refTitle}
                          displayProperty={"Title"}
                          propertyName={"title_Activity"}
                          FixPosition={false}
                          PortalTarget={false}
              isRequired={true}

                        />
             <NuTextArea
              label="Description"
              placeholder="Description"
              formik={formik}
              name="description"
              width="w-full"
              new_width="w-full"

            />
           
           <button
              type="submit"
             
              className="w-11/12 bg-textColor-main py-3 rounded-lg cursor-pointer text-sm outline-none border-none hover:text-white focus:text-white text-white  mx-auto"
            >
              Create 
            </button>
          </div>
     
    </form>
    </Modal>
    </>
  );
};
export default CreateCondition